import { render, staticRenderFns } from "./OneProductGrid.vue?vue&type=template&id=2af9454f&scoped=true&"
import script from "./OneProductGrid.vue?vue&type=script&lang=js&"
export * from "./OneProductGrid.vue?vue&type=script&lang=js&"
import style0 from "./OneProductGrid.vue?vue&type=style&index=0&id=2af9454f&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2af9454f",
  null
  
)

export default component.exports